import { useTranslation } from "react-i18next";
import { useIsDesktop } from "../../../../hooks/useIsDesktop";
import {
  Box,
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import { Close, FilterAlt } from "@mui/icons-material";
import { forwardRef } from "react";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function FiltersDesktopUserListingPage({
  filterComponents,
  dialogOpen,
  onDialogOpen,
  onDialogClose,
  onReset,
}) {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation();

  if (isDesktop) {
    return (
      <Box sx={{ mb: 2 }}>
        <Grid container spacing={3} alignItems="flex-start">
          {filterComponents.map((filter, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              {filter.component}
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      {/* Filter open button */}
      <Button
        variant="outlined"
        startIcon={<FilterAlt />}
        onClick={onDialogOpen}
        fullWidth
        sx={{ mb: 2 }}
        data-testid="users.page.filters.trigger"
      >
        {t("Filters")}
      </Button>

      <Dialog
        open={dialogOpen}
        onClose={onDialogClose}
        fullScreen
        TransitionComponent={Transition}
        TransitionProps={{
          mountOnEnter: true,
          unmountOnExit: true,
          timeout: 300,
        }}
        data-testid="users.page.filters.dialog"
      >
        {/* Filter title */}
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{
            px: 2,
            py: 1,
            my: 1,
            position: "relative",
          }}
        >
          <IconButton
            aria-label={t("Close")}
            title={t("Close")}
            onClick={onDialogClose}
            size="large"
            sx={{ color: "red" }}
            data-testid="users.page.filters.close-button"
          >
            <Close />
          </IconButton>
          <Typography variant="h5">{t("Filter")}</Typography>
        </Stack>

        <Container sx={{ mt: 1 }}>
          {/* Filter content */}
          <Stack spacing={3}>
            {filterComponents.map((filter, index) => (
              <Box key={index}>
                <Typography variant="h6">{t(filter.label)}</Typography>
                <Divider sx={{ mb: 2 }} />
                {filter.component}
              </Box>
            ))}
          </Stack>

          <Divider sx={{ mt: 3 }} />
          <Stack direction="row" justifyContent="space-evenly" sx={{ mt: 2 }}>
            <Button
              startIcon={<Close />}
              color="error"
              onClick={onReset}
              variant="contained"
              fullWidth
              size="large"
              data-testid="users.page.filters.reset-button"
            >
              {t("Reset")}
            </Button>
          </Stack>
        </Container>
      </Dialog>
    </Box>
  );
}
